class LocalizationForm extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      button: this.querySelector('button'),
      panel: this.querySelector('.i18n-panel'),
      currencies: this.querySelector('select.currencies-select'),
      languages: this.querySelector('select.languages-select'),
    };

    // open/close dropdown
    this.elements.button.addEventListener('click', this.toggleSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));

    // currency selection
    this.elements.currencies.addEventListener('change-manual', this.setCurrency.bind(this));
    this.elements.currencies.addEventListener('change', this.setCurrency.bind(this));

    // language selection
    this.elements.languages.addEventListener('change', this.setLanguage.bind(this));
  }

  isSelectorOpened() {
    return this.elements.button.getAttribute('aria-expanded') === 'true';
  }

  setCurrency(e) {
    this.querySelector('.selected-currency').innerHTML = this.elements.currencies.value;

    // only toggle the selector if the change was triggered through a user action.
    if (e.type === 'change' && this.isSelectorOpened()) {
      this.toggleSelector();
    }
  }

  setLanguage() {
    this.querySelector('#localization_form')?.submit();
  }

  setPanelDirection() {
    // sets the dropdown position depending on the available space
    // credits: chatgpt
    const { panel } = this.elements;
    const spaceBelow = window.innerHeight - this.getBoundingClientRect().bottom;

    if (spaceBelow < panel.offsetHeight) {
      panel.style.bottom = '100%';
      panel.style.top = 'auto';
    } else {
      panel.style = null;
    }
  }

  toggleSelector() {
    this.elements.panel.classList.toggle('tw-hidden');
    this.elements.button.setAttribute(
      'aria-expanded',
      (this.elements.button.getAttribute('aria-expanded') === 'false').toString(),
    );

    const caretEl = this.elements.button.querySelector('.caret-down');
    if (caretEl) {
      caretEl.classList.toggle('tw-rotate-180');
    }

    if (this.isSelectorOpened()) {
      this.setPanelDirection();
    } else {
      this.elements.panel.style = null;
    }
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';

    if (this.isSelectorOpened() && (event.relatedTarget === null || shouldClose)) {
      this.toggleSelector();
    }
  }
}

customElements.define('localization-form', LocalizationForm);
